import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";

export const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Se difiere un frame para no leer el layout (offsetTop de cada nodo
    // data-aos) en el mismo tick que el remontaje completo de la ruta,
    // que es lo que Lighthouse marca como "reprocesamiento forzado".
    requestAnimationFrame(() => AOS.refresh());
  }, [pathname]);

  return null;
};
